<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Table Row Entry</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
    <div class="skylark-form-entry">
      <div class="background-inner">

        <ng-container *ngFor="let field of tableData; let i = index;">

          <!-- inputs -->
          <!-- text field -->
          <ng-container *ngIf="field.type === 'textField'">

            <label>{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">response required</span></label>
            <input type="text" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- text area -->
          <ng-container *ngIf="field.type === 'textArea'">

            <label>{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">response required</span></label>
            <textarea [(ngModel)]="answers[i]"></textarea>

          </ng-container>

          <!-- date field -->
          <ng-container *ngIf="field.type === 'dateField'">

            <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">date required</span></label>
            <input type="date" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- time field -->
          <ng-container *ngIf="field.type === 'timeField'">

            <label>{{field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">time required</span></label>
            <input type="time" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- radio button list -->
          <ng-container *ngIf="field.type === 'radioButton'">
            <div class="list-group">
              <span class="list-group-header">{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">select one</span> </span>

              <ng-container *ngFor="let option of field.options; let ro = index">
                <div class="radio-button-line">
                  <label class="radio-label">
                    <input type="radio" [name]="'radio_' + i" [value]="option" [(ngModel)]="answers[i]">
                    {{option}}
                  </label>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- checkbox list -->
          <ng-container *ngIf="field.type === 'checkboxList'">
            <div class="list-group">
              <span class="list-group-header">{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">select at least one</span></span>
                <ng-container *ngFor="let option of field.options; let co = index" [ngValue]="option">
                <div class="checkbox-button-line">
                  <label class="radio-label">
                    <input type="checkbox" [name]="'checkbox_' + i" [value]="option" (change)="setCheckboxValue(i, option, $event)">
                    {{option}}
                  </label>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div *ngIf="validationErrors.length" class="validation-alert">
      <br/>
      <span class="required-star">- Please fix all errors before proceeding</span>
    </div>

    <button class="btn btn-success btn-sm float-right"  (click)="saveRow()">Save Row</button>
    <button class="btn btn-danger btn-sm float-right"  (click)="deleteRow()">Delete Row</button>
    <button class="btn btn-secondary btn-sm float-right" (click)="closeModal()">Cancel</button>


</div>


